<template>
  <el-carousel :interval="5000" type="card" height="320px" arrow="always" :loop="false" :initial-index="1">
    <el-carousel-item style="text-align:center" :key="index" v-for="(item, index) in offlineCoursesList">
      <img style="width:360px;height:240px" @click="changePage(item.courseId)"  :src="item.coursePic" alt="" />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "SwiperCard",
  props: {
    offlineCoursesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // swiperOption:{
      //     speed:400,
      //     loop:true,
      //     loopAdditionalSlides:3,
      //     autoplayStopOnLast:false,
      //     grabCursor:true,
      //     loopedSlides:3
      // },
    };
  },
  mounted() {},
  methods: {
    changePage(id){
      this.$router.push("offlineCourseDetail?courseId="+id)
    },
  },
  created() {},
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/swiper_card.vue